import {
  HStack,
  Divider,
  Text,
  type HStackProps,
} from '@frontend/legacy-components';

type NamedDividerProps = {
  label: string;
} & Omit<HStackProps, 'children'>;

export const NamedDivider = ({ label, ...stackProps }: NamedDividerProps) => {
  return (
    <HStack align="center" spacing={2} marginBlock={-0.5} {...stackProps}>
      <Divider variant="dashed" flex={1} />
      <Text
        size="sm"
        color="feature.secondary"
        fontWeight="medium"
        whiteSpace="nowrap"
      >
        {label}
      </Text>
      <Divider variant="dashed" flex={1} />
    </HStack>
  );
};
